import { isEmpty } from "lodash";
import api from "../../../api";

export function getOadOrders(type, filter, sd, ed) {
  let url = `get-oad-order?order_type=${type}`;
  if (!isEmpty(filter) && filter.oda_type) {
    url += `&oad_type=${filter.oda_type}`;
  }

  if (!isEmpty(filter) && filter.allocationStatus) {
    url += `&allocationStatus=${filter.allocationStatus}`;
  }

  if (!isEmpty(filter) && filter.allocationStatusReason) {
    url += `&allocationStatusReason=${filter.allocationStatusReason}`;
  }

  if (!isEmpty(filter) && filter.orderPaymentType) {
    url += `&orderPaymentType=${filter.orderPaymentType}`;
  }

  if (!isEmpty(filter) && filter.orderStatus) {
    url += `&order_status=${filter.orderStatus}`;
  }

  if (!isEmpty(filter) && filter.warehouse) {
    url += `&warehouse_type=${filter.warehouse}`;
  }

  if (!(!sd || sd === "" || ed === "" || !ed)) {
    url += `&startDate=${sd}&endDate=${ed}`;
  }
  return api.get(url);
}

export function getFlaggedInvoice(page, sd, ed, filter) {
  return api.get(
    `flagged-invoices?pageNumber=${page}&pageSize=10&filter=${filter}`
  );
}

export function processOrder(orders, type) {
  return api.post(`process-oad-order?type=${type}`, orders);
}

export function getProzoPendingOrders(page, sd, ed, filter) {
  let url = `prozo-pending-order?`;

  if (!isEmpty(filter) && filter.order_type) {
    if (url.endsWith("?")) url += `&order_type=${filter.order_type}`;
    else url += `?order_type=${filter.order_type}`;
  }

  if (!(!sd || sd === "" || ed === "" || !ed)) {
    if (url.endsWith("?")) url += `&startDate=${sd}&endDate=${ed}`;
    else url += `?startDate=${sd}&endDate=${ed}`;
  }

  if (!isEmpty(filter) && filter.orderPaymentType) {
    url += `&orderPaymentType=${filter.orderPaymentType}`;
  }
  return api.get(url);
}

export function getShippingPendingOrders(page, sd, ed, filter) {
  return api.post(
    `order/flagged?pageNumber=${page}&pageSize=10&filter=${filter}`,
    { startDate: sd, endDate: ed }
  );
}

export function uploadInvoiceInfo(formData){
	return api.put('upload-invoice-and-info', formData)
}

export function AllWarehouses(){
	return api.get('get-valid-warehouses')
}

export function ValidWarehouse(orderId){
	 return api.get(`check-valid-wearhouse/${orderId}`)
}

export function updateWarehouse(updatedData) {
	return api.post('order/update-fulfillment', updatedData)
}

export function markShippedApi(payload,orderId) {
	return api.post(`order/${orderId}/markShipped`, payload)
}

export function getOrderTrackingInfo(orderId) {
	return api.get(`order-tracking-info/${orderId}`)
}